import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Block } from './library/container';
export const QuoteBlock = (props)=>/*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "quote container--sg align--center",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "quote__text title--m",
                    children: props.quote
                }),
                props.source && /*#__PURE__*/ _jsx("div", {
                    className: "quote__name text--s",
                    children: props.source
                })
            ]
        })
    });
{}